import type { PersonDto } from "@caloteiros/shared";
import type { ReactElement } from "react";
import { firstName } from "../lib/format";
import { Avatar } from "./ui";

/** Fileira de chips para escolher varias pessoas — a divisao da despesa. */
export function PersonChips({
  people,
  selected,
  onToggle,
  emptyLabel = "Ninguém no grupo ainda.",
}: {
  people: PersonDto[];
  selected: Set<string>;
  onToggle: (personId: string) => void;
  emptyLabel?: string;
}): ReactElement {
  if (people.length === 0) {
    return <p className="muted">{emptyLabel}</p>;
  }

  return (
    <div className="chip-list">
      {people.map((person) => (
        <button
          key={person.id}
          type="button"
          className="chip"
          aria-pressed={selected.has(person.id)}
          onClick={() => onToggle(person.id)}
        >
          <Avatar name={person.displayName} color={person.avatarColor} size="sm" />
          {firstName(person.displayName)}
        </button>
      ))}
    </div>
  );
}

/** Escolha de uma pessoa so — quem pagou, quem recebeu. */
export function PersonSelect({
  people,
  value,
  onChange,
  allowEmpty = false,
  emptyLabel = "Ninguém",
}: {
  people: PersonDto[];
  value: string | null;
  onChange: (personId: string | null) => void;
  allowEmpty?: boolean;
  emptyLabel?: string;
}): ReactElement {
  return (
    <select
      className="select"
      value={value ?? ""}
      onChange={(event) => onChange(event.target.value === "" ? null : event.target.value)}
    >
      {allowEmpty ? <option value="">{emptyLabel}</option> : null}
      {people.map((person) => (
        <option key={person.id} value={person.id}>
          {person.displayName}
          {person.isMe ? " (você)" : ""}
        </option>
      ))}
    </select>
  );
}
